import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { FormStepContext } from './FormStepContext';
import errorImage from '../../assets/images/error-state.svg';
import EmptyReport from './EmptyReport';
import PendingState from '../loader/PendingState';

const ErrorMessage = ({ errorMessage, setSending }) => {
  const onCloseMessage = () => {
    setSending(false);
  };

  return (
    <div>
      <div>
        <img src={errorImage} width="308" height="216" alt="Error state" />
        <p>{errorMessage}</p>
        <button
          type="button"
          className="primaryFatLink"
          onClick={onCloseMessage}
          id="btn-try-again--popup"
        >
          Try again
        </button>
      </div>
    </div>
  );
};

const SixthStep = () => {
  const {
    currentStep,
    register,
    watch,
    formStateErrors,
    isSent,
    setSending,
    isError,
    errorMessage,
    activeStep,
    setStep,
  } = useContext(FormStepContext);

  const { loading } = useSelector((s) => s.form);
  const watchedName = watch('name');
  const watchedEmail = watch('email');
  const emptyFields = !watchedName || !watchedEmail;
  const [isVisibleFakeLoader, setIsVisibleFakeLoader] = useState(true);

  const showErrorMessage = isSent && !loading && isError;
  const showPendingMessage = isSent && loading;
  //   HY8STgUrTpLHeG8LdF8ap

  useEffect(() => {
    if (activeStep === currentStep.id) {
      setTimeout(() => {
        setIsVisibleFakeLoader(false);
      }, 5000);
    }
  }, [activeStep, currentStep]);

  const onSetPrevStep = () => {
    setStep(currentStep.id - 1);
  };

  return (
    <div className="laForm__stage-item__report-step">
      {isVisibleFakeLoader ? (
        <div className="laForm">
          <PendingState />
        </div>
      ) : (
        <>
          <EmptyReport />
          <div className="laForm__stage-item__dialog">
            <div className="laForm__stage-item__confirmationModal">
              <div className="laForm__stage-item__confirmationModal__body">
                {showErrorMessage && (
                  <ErrorMessage
                    errorMessage={errorMessage}
                    setSending={setSending}
                  />
                )}
                {showPendingMessage ? (
                  <>
                    <div className="confirmationModal__pending-state">
                      <div className="confirmationModal__pending-state__loader">
                        <div />
                      </div>
                      <h3>Verification</h3>
                      <p className="clr-gray">Please wait for a few seconds</p>
                    </div>
                  </>
                ) : (
                  !isSent && (
                    <>
                      <h3>Enter your email address to&nbsp;save the report</h3>
                      <p>
                        <strong>
                          We do not send spam or share information with third
                          parties.
                        </strong>
                      </p>
                      <div className="form">
                        <div>
                          <input
                            type="text"
                            {...register('name')}
                            placeholder="Name"
                            maxLength={100}
                          />
                          {formStateErrors.name && (
                            <p className="errorMessage">
                              {formStateErrors.name.message}
                            </p>
                          )}
                        </div>
                        <div>
                          <input
                            type="email"
                            {...register('email')}
                            placeholder="Email"
                          />
                          {formStateErrors.email && (
                            <p className="errorMessage">
                              {formStateErrors.email.message}
                            </p>
                          )}
                        </div>

                        <button
                          type="submit"
                          className="primaryFatLink"
                          disabled={emptyFields}
                          id="submit-email"
                        >
                          Submit
                        </button>

                        <button
                          type="button"
                          className="btn-close"
                          title="Close"
                          onClick={onSetPrevStep}
                        />
                      </div>
                    </>
                  )
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SixthStep;
